import React from "react";
import { createPortal } from "react-dom";
import { Modal, Form, Input, Button, message } from "antd";
import { useCreateVillageMutation } from "../../../Redux/service/CallCenter/CallCenter";

const CreateVillageModal = ({ visible, onClose, governorate, markaz, onSuccess }) => {
  const [form] = Form.useForm();
  const [createVillage, { isLoading }] = useCreateVillageMutation();
  const lang = localStorage.getItem("lang") === "ar" ? "ar" : "en";

  const handleSubmit = async (values) => {
    try {
      const result = await createVillage({
        governorate,
        markaz,
        name: values.name,
        nameAr: values.nameAr,
      }).unwrap();

      message.success(
        lang === "ar" ? "تم إنشاء القرية بنجاح" : "Village created successfully"
      );
      form.resetFields();
      onSuccess(result.data);
      onClose();
    } catch (err) {
      if (err?.status === 409 && err?.data?.data) {
        // Someone else already created the identical village concurrently —
        // treat it as a soft success and select the row that won the race
        // instead of dead-ending the agent with a generic error.
        message.info(
          lang === "ar"
            ? "هذه القرية موجودة بالفعل — تم اختيارها"
            : "This village already exists — selected it for you"
        );
        form.resetFields();
        onSuccess(err.data.data);
        onClose();
        return;
      }
      message.error(err?.data?.message || "Something went wrong");
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  return createPortal(
    <Modal
      title={lang === "ar" ? "إضافة قرية جديدة" : "Add New Village"}
      open={visible}
      onCancel={handleCancel}
      footer={null}
      width={500}
      zIndex={2000}
      destroyOnClose={true}
      maskClosable={false}
    >
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Form.Item
          label={lang === "ar" ? "الاسم (إنجليزي)" : "Name (English)"}
          name="name"
          rules={[{ required: true, message: lang === "ar" ? "مطلوب" : "Required" }]}
        >
          <Input placeholder={lang === "ar" ? "أدخل الاسم بالإنجليزية" : "Enter name in English"} />
        </Form.Item>

        <Form.Item
          label={lang === "ar" ? "الاسم (عربي)" : "Name (Arabic)"}
          name="nameAr"
          rules={[{ required: true, message: lang === "ar" ? "مطلوب" : "Required" }]}
        >
          <Input
            placeholder={lang === "ar" ? "أدخل الاسم بالعربية" : "Enter name in Arabic"}
            dir="rtl"
          />
        </Form.Item>

        <div className="d-flex justify-content-end gap-2">
          <Button onClick={handleCancel}>
            {lang === "ar" ? "إلغاء" : "Cancel"}
          </Button>
          <Button type="primary" htmlType="submit" loading={isLoading}>
            {lang === "ar" ? "إنشاء" : "Create"}
          </Button>
        </div>
      </Form>
    </Modal>,
    document.body
  );
};

export default CreateVillageModal;
